import { CheckIcon, XIcon } from '@phosphor-icons/react';
import type { ChatUiApprovalResult } from '@voll-intelligence/genui-contract';
import { CardFooter } from '../../../shared/ui/card.js';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';
import '@voll-intelligence/intelligence-ui-kit/flight-offers.css';
import '../../../shared/ui/flight_ui.css';
import '../../shared/approval.css';

/**
 * Card de resultado da aprovação (`approval_result`) — display-only, emitido pelo
 * handler determinístico DEPOIS de publicar a decisão. Sem interação: só o selo
 * (Aprovado/Reprovado) + o status (publicado/falhou) e o voucher quando presente.
 */
export function ApprovalResultCard({
  result,
  note,
}: {
  readonly result: ChatUiApprovalResult;
  readonly note?: string;
}) {
  const { t } = useGenUiI18n();
  const failed = result.status === 'failed';
  const approved = result.decision === 'approve';
  // Verde/vermelho pela decisão; cinza esmaecido sobrepõe quando a publicação falhou.
  const decisionTone = approved ? 'is-approve' : 'is-deny';
  const tone = failed ? 'is-failed' : decisionTone;
  const label = approved ? t('approval.approved') : t('approval.denied');
  return (
    <section className="fui" aria-label={t('approval.resultAria')}>
      <div className="fui-card">
        <div className="fui-body">
          <span className={`appr-result ${tone}`}>
            {approved && !failed ? (
              <CheckIcon size={14} aria-hidden />
            ) : (
              <XIcon size={14} aria-hidden />
            )}
            {failed ? t('approval.publishFailed', { label }) : label}
          </span>
          {result.voucherCode && (
            <div className="fui-cf-summary">
              <span className="fui-k">{t('approval.voucher')}</span>
              <span className="fui-v is-mono">{result.voucherCode}</span>
            </div>
          )}
        </div>
        <CardFooter note={note} />
      </div>
    </section>
  );
}

/* ── Ícones (SVG inline; mesmos traços do card de pedido) ────────────── */
